import { FC, SVGAttributes } from 'react';

const ArrowLeft: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7782 4.22257C16.2078 4.65215 16.2078 5.34863 15.7782 5.77821L9.55603 12.0004L15.7782 18.2226C16.2078 18.6522 16.2078 19.3486 15.7782 19.7782C15.3486 20.2078 14.6521 20.2078 14.2226 19.7782L7.22257 12.7782C6.793 12.3486 6.793 11.6521 7.22257 11.2226L14.2226 4.22257C14.6521 3.793 15.3486 3.793 15.7782 4.22257Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowLeft;
